import { makeStyles } from 'tss-react/mui';

export const useBasePieChartStyles = makeStyles()(theme => {
  const isLightTheme = theme.palette.mode === 'light';

  return {
    root: {
      borderRadius: 30,
      overflow: 'hidden',

      /* TODO: reuse this styles in other scrollable widgets */
      display: 'flex',
      flexDirection: 'column',
      padding: theme.spacing(5, 2, 5, 5),
      backgroundImage: 'none',
      paddingBottom: 0,
      position: 'relative',

      '&:after': {
        content: '""',
        display: 'block',
        position: 'sticky',
        left: 0,
        bottom: 20,
        width: '100%',
        height: 40,
        background: isLightTheme
          ? 'linear-gradient(180deg, rgba(255, 255, 255, 0.04) 0%, #FFF 75%)'
          : 'linear-gradient(180deg, rgba(0, 0, 0, 0.04) 0%, #2E343C 75%)',
      },
    },
    tableItemName: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: theme.spacing(2),
    },
    tableItemNameText: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '100%',
    },
    dot: {
      flexShrink: 0,
      width: 8,
      height: 8,
      borderRadius: '50%',
    },
    title: {
      marginBottom: theme.spacing(2),
    },
    content: {
      display: 'flex',
      flexDirection: 'row',
      gap: theme.spacing(2),
      height: '100%',
    },
    chartWrapper: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      width: '50%',

      [theme.breakpoints.down('lg')]: {
        display: 'none',
      },
    },
    chart: {
      width: '75%',
      height: '75%',
    },
    chartDataTable: {
      width: '50%',
      paddingTop: 0,
      paddingLeft: 0,
      paddingRight: theme.spacing(1),
      overflow: 'visible',

      [theme.breakpoints.down('lg')]: {
        width: '100%',
      },
    },
  };
});
